<template>
    <Icon :icon="icon" spinning :size="size" :small="small" :x-large="xLarge" :xx-large="xxLarge" :x-small="xSmall" :large="large" :color="color"/>
</template>

<script>
import IconMixin from "./IconMixin";
	import {mdiLoading} from "@mdi/js";

    export default {
        name: 'LoadingIcon',
        mixins: [IconMixin],

		data() {
			return {
				icon: mdiLoading
			}
		}

    }
</script>
